import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AppFilter } from '@app/shared/models';

@Injectable({
  providedIn: 'root',
})
export class GeofencingMgtService {
  apiUrl: string = environment.API_SERVER;
  apiUrlTwo = 'https://restcountries.com/v3.1/all';
  constructor(private _http: HttpClient) {}

  getGeofenceProfiles(payload) {
    return this._http.get(`${this.apiUrl}/api/v1/geo-fence/profiles`, {
      params: payload.params,
    });
  }

  getGeofenceUserWithProfile(payload) {
    return this._http.get(
      `${this.apiUrl}/api/v1/geo-fence/user-with-profiles`,
      {
        params: payload.params,
      }
    );
  }
  getGeofenceAllowedCountries(payload) {
    return this._http.get(
      `${this.apiUrl}/api/v1/geo-fence/countries?status=ALLOWED`,
      {
        params: payload.params,
      }
    );
  }
  getGeofenceDisAllowedCountries(payload) {
    return this._http.get(
      `${this.apiUrl}/api/v1/geo-fence/countries?status=DISALLOWED`,
      {
        params: payload.params,
      }
    );
  }

  getGeofenceLogs(payload) {
    return this._http.get(
      `${this.apiUrl}/api/v1/event-logs/by-type?eventType=GEO_FENCE`,
      {
        params: payload.params,
      }
    );
  }

  addGeofenceProfile(body) {
    return this._http.post(`${this.apiUrl}/api/v1/geo-fence/profile`, body);
  }
  editGeofenceProfile(payload) {
    return this._http.put(
      `${this.apiUrl}/api/v1/geo-fence/profile/${payload.geofenceProfileId}`,
      payload.body
    );
  }

  deleteGeofenceProfile(payload) {
    return this._http.delete(
      `${this.apiUrl}/api/v1/geo-fence/profile/${payload.geofenceProfileId}`
    );
  }

  getRateLimitProfiles(payload) {
    return this._http.get(`${this.apiUrl}/api/v1/rate-limit/profiles`, {
      params: payload.params,
    });
  }
  assignGeofenceProfile(payload) {
    return this._http.put(
      `${this.apiUrl}/api/v1/geo-fence/profile/${payload.geofenceProfileId}/assign/${payload.appUserId}`,
      {}
    );
  }
  unAssignGeofenceProfile(payload) {
    return this._http.put(
      `${this.apiUrl}/api/v1/geo-fence/profile/${payload.geofenceProfileId}/un-assign/${payload.appUserId}`,
      {}
    );
  }

  deleteGeofenceCountry(payload) {
    return this._http.delete(
      `${this.apiUrl}/api/v1/geo-fence/country/${payload.geofenceCountryId}`,
      {}
    );
  }
  assignRateLimitProfile(payload) {
    return this._http.put(
      `${this.apiUrl}/api/v1/rate-limit/profile/${payload.rateLimitProfileId}/assign/${payload.appUserId}`,
      {}
    );
  }
  getAllCountries() {
    let filter = new AppFilter({ sidx: 'countryName', rows: 300 });
    return this._http.get(`${this.apiUrl}/public/countries`, {
      params: filter as any,
    });
  }
  addCountry(payload) {
    return this._http.post(
      `${this.apiUrl}/api/v1/geo-fence/country`,
      payload.body
    );
  }
  unAssignRateLimitProfile(payload) {
    return this._http.get(
      `${this.apiUrl}/api/v1/rate-limit/profile/${payload.rateLimitProfileId}/un-assign/${payload.appUserId}`
    );
  }
}
